import React, { useState } from 'react';

import { useParams } from "react-router-dom";
import Loader from 'react-loader-spinner';
import { useList } from '../../hooks/listHook';
import { useItem } from '../../hooks/itemHook';
import NotFound from '../../useful/NotFound';
import { withAuthorization } from '../../session';

import ModalInfo from '../../useful/ModalInfo';
import PremiumUserTournament from './PremiumUserTournament';
import EmptyList from '../../useful/EmptyList';
import PremiumUserData from './PremiumUserData';

const PremiumUserPage = (props) => {

    const { user_uid } = useParams(); // user uid

    const { loading: loadingPremiumUser, item: premiumUser } = useItem(props.firebase.premiumUserDoc(user_uid), user_uid);
    const { loading: loadingTournaments, list: tournaments } = useList(props.firebase.tournamentList(user_uid), user_uid);

    const loading = loadingPremiumUser && loadingTournaments;

    const [modal, setModal] = useState({ show: false, title: '', message: '' });

    if (!loadingPremiumUser && premiumUser == null) {
        return <NotFound />
    }

    const showModal = (title, message) => {
        setModal({ show: true, title, message });
    }

    const tableHead =
        <thead className="">
            <tr >
                <th className="" style={{ width: 25 }}></th>
                <th className="" >NOMBRE</th>
                <th className="text-center">GÉNERO</th>
                <th className="text-center">TIPO</th>
                <th className="text-center">MODALIDAD</th>
                <th className="text-center" style={{ width: 40 }}></th>
            </tr>
        </thead>

    const listView = (tournaments && tournaments.length > 0) ?
        tournaments.map((item, i) => {
            return (
                <PremiumUserTournament key={i} tournament={item} showModal={showModal} />
            )
        })
        :
        <tr>
            <td colSpan={6}>
                <EmptyList />
            </td>
        </tr>

    return (
        <div className="bg-white border rounded-lg">

            <PremiumUserData loading={loadingPremiumUser} user={premiumUser} />

            <div className="col-12 p-2">

                <h6 className="font-weight-bolder">Listado de torneos</h6>

                {(!loading) ?
                    <table className="table table-responsive-sm table-sm small ">
                        {tableHead}
                        <tbody>
                            {listView}
                        </tbody>
                    </table>
                    :
                    <div className="nav justify-content-center row">
                        <Loader className="mt-4"
                            type="ThreeDots"
                            color="#263238"
                            height={60}
                            width={60}
                            timeout={0} />
                    </div>
                }

            </div>

            <ModalInfo
                data={modal}
                onClose={() => setModal({ show: false, title: '', message: '' })}
            />

        </div>
    )
}

const condition = authUser => {
    if (!!authUser) {
        return authUser.token.admin === true;
    } else
        return false;
};
export default withAuthorization(condition)(PremiumUserPage);